import { StarOutlined } from '@mui/icons-material';
import { ListItemIcon, ListItemText } from '@mui/material';

import { useMutation } from '@/hooks/mutationWithSnackbar';

import type { DocumentType } from '@/gql';
import { graphql } from '@/gql';

import { MaybeUsableMenuItem } from './MaybeUnusableMenuItem';

const PIN_FILE_MUTATION = graphql(`
  mutation PinFile($data: PinFileInput) {
    pinFile(params: $data) {
      file {
        ...fileFields
      }
    }
  }
`);

const PIN_FILE_MENU_ITEM_FILE_FRAGMENT = graphql(`
  fragment pinFileMenuItemFileFields on File {
    ...fileFields
  }
`);

interface Props {
  file: DocumentType<typeof PIN_FILE_MENU_ITEM_FILE_FRAGMENT>;
  canEdit: boolean;
  canLockRoot: boolean;
  unusableExplanation: string | null;
  onClose: () => void;
}

export const PinFileMenuItem = ({
  file,
  canEdit,
  canLockRoot,
  unusableExplanation,
  onClose,
}: Props) => {
  const { _id: fileId } = file;

  const [pinFile] = useMutation(PIN_FILE_MUTATION, {
    optimisticResponse: {
      pinFile: {
        __typename: 'PinFileResult',
        file: {
          ...file,
          pinned: true,
        },
      },
    },
  });

  return (
    <>
      <MaybeUsableMenuItem
        isUsable={canEdit}
        isExpectedUsable={canLockRoot}
        unusableExplanation={unusableExplanation}
        onClick={() => {
          onClose();
          pinFile({
            variables: {
              data: {
                file: fileId,
              },
            },
          });
        }}
      >
        <ListItemIcon>
          <StarOutlined />
        </ListItemIcon>
        <ListItemText primary="Pin to top of folder" />
      </MaybeUsableMenuItem>
    </>
  );
};
